//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { genId } from '@/plugins/utils'

export default {
  name: 'CompanyOwnerPage',

  layout: 'page',

  data() {
    const { query } = this.$route

    return {
      id: query.id,
      owners: [],
      formLoading: false,
      newsletterOptions: [
        { label: '受け取る', value: true },
        { label: '受け取らない', value: false },
      ],
    }
  },

  computed: {
    allowSubmit() {
      return this.owners.every((owner) => {
        return owner.name && owner.name_kana && owner.email
      })
    },
  },

  mounted() {
    this.fetchDetail()
  },

  methods: {
    async fetchDetail() {
      this.formLoading = true

      const res = await this.$axios.$get('/company/detail', {
        params: {
          id: this.id,
        },
      })

      this.formLoading = false

      if (!res.data) {
        return {}
      }

      const { id, owners } = res.data

      this.id = id
      this.owners = owners.map((owner) => ({
        id: genId(),
        ...owner,
        newsletter: owner.email.includes(',') ? false : owner.newsletter,
      }))
    },
    addOwner() {
      this.owners.push({
        id: genId(),
        name: '',
        name_kana: '',
        email: '',
        mobile_phone: '',
        newsletter: true,
      })
    },
    delOwner(index) {
      this.owners.splice(index, 1)
    },
    async save() {
      const form = {
        id: this.id,
        owners: this.owners.map(({ id, ...owner }) => owner),
      }

      this.formLoading = true

      const res = await this.$axios.post('/company/info', form)

      this.formLoading = false

      if (res.status !== 200) {
        return
      }

      this.$toast({
        message: '保存しました',
      })

      this.$router.push('/company/detail')
    },
    doNewsletterChange(item, index) {
      // check other owners.*.email is same, if same, change other newsletter to current item newsletter
      const currentEmail = item.email

      this.owners = this.owners.map((owner, idx) => {
        if (idx !== index && owner.email === currentEmail) {
          owner.newsletter = item.newsletter
        }

        return owner
      })
    },
    doEmailChange(item, index) {
      // check other owners.*.email is same, if same, use other newsletter to set current item newsletter
      this.owners = this.owners.map((owner, idx) => {
        if (idx !== index && owner.email === item.email) {
          item.newsletter = owner.newsletter
        }

        return owner
      })
    },
  },
}
